import { InjectionToken } from '@angular/core';
import { isWhiteLabel } from '@shared/white-label.config';

/**
 * Whether Freight matching is offered, under Tools and as a shipment profile
 * tab. Tiltgroup only: its model is trained on Tiltgroup's own loads, so
 * white-label builds (polt.ai) hide it. An injection token so specs can cover both states.
 */
export const FREIGHT_MATCHING_ENABLED = new InjectionToken<boolean>(
  'FREIGHT_MATCHING_ENABLED',
  { providedIn: 'root', factory: () => !isWhiteLabel }
);
